import { useState, useEffect, useCallback, useMemo } from "react";

import Header from "../../../components/Layout/Header";
import Footer from "../../../components/Layout/Footer";
import Sidebar from "../../../components/Layout/Sidebar";
import TableSkeleton from "../../components/skeleton/TableSkeleton";

import { useNavigate } from "react-router-dom";

import { Modal, Button } from "react-bootstrap";
import DataTable from "react-data-table-component";

import { getData as getVenue } from "../../../services/admin/defaultSetup/esVenueServices";

import {
  getData,
  deleteData,
} from "../../../services/admin/defaultSetup/hotelSetupServices";

const HotelSetupList = () => {
  const navigate = useNavigate();
  const [dataList, setDataList] = useState([]);

  // permission state
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  // Fetch data list
  const fetchData = useCallback(async () => {
    try {
      const data = await getData();
      setDataList(data);
    } catch (error) {
      console.error("Failed to fetch data:", error);
    }
  }, []);

  useEffect(() => {
    const fetchDataAsync = async () => {
      setLoading(true);
      await fetchData();
      // Optional 1 second delay
      await new Promise((resolve) => setTimeout(resolve, 1000));
      setLoading(false);
    };

    fetchDataAsync();
  }, [fetchData]);

  const handleDelete = async () => {
    if (selectedData) {
      // Optimistically remove the data from the list
      setDataList((prev) => prev.filter((data) => data.id !== selectedData.id));
      // Proceed with the actual delete request
      await deleteData(selectedData);
      setShowDeleteConfirmModal(false);
    }
  };

  const openDeleteConfirmModal = (data) => {
    setSelectedData(data);
    setShowDeleteConfirmModal(true);
  };

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Memoized filtered data based on search query
  const filteredData = useMemo(() => {
    return dataList
      .filter(
        (data) =>
          data.venue &&
          data.venue.toLowerCase().includes(searchText.toLowerCase()),
          )
      .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
  }, [dataList, searchText]);

  const columns = [
    {
      name: "#",
      selector: (row, index) => (currentPage - 1) * 10 + (index + 1),
      sortable: false,
      width: "80px",
    },
    {
      name: "Hotel Name",
      selector: (row) => <span title={row.hotel_name}>{row.hotel_name}</span>,
      sortable: true,
    },
    {
      name: "Venue",
      selector: (row) => <span title={row.venue}>{row.venue}</span>,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div>
          <Button
            className="me-2"
            variant="warning"
            size="sm"
            onClick={() =>
              navigate("/HotelSetup", {
                state: { type: "edit", data: row },
              })
            }
          >
            {" "}
            Edit{" "}
          </Button>
          <Button
            variant="danger"
            size="sm"
            onClick={() => openDeleteConfirmModal(row)}
          >
            {" "}
            Delete{" "}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div className="d-flex">
      <Sidebar />
      <div className="main-content w-100">
        <Header />

        <div>
          <div className="container-fluid p-4">
            <div className="row">
              <div className="col-8">
                <h3 className="mb-4">
                 General Configuration / Default Setup / Hotel Setup 
                </h3>
              </div>
              <div className="col-4 text-end">
                <button
                  className="btn btn-primary mb-3"
                  onClick={() =>
                    navigate("/HotelSetup", {
                      state: { type: "add" },
                    })
                  }
                >
                  Add
                </button>
              </div>
            </div>

            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              search
              highlightOnHover
              responsive
              striped
              paginationPerPage={10}
              paginationRowsPerPageOptions={[10, 20, 50, 100, 200, 500]}
              onChangePage={handlePageChange}
              subHeader
              subHeaderComponent={
                <div>
                  <input
                    className="form-control"
                    type="text"
                    placeholder="Search a Venue"
                    value={searchText}
                    onChange={handleSearchChange}
                  />
                </div>
              }
              progressPending={loading}
              progressComponent={<TableSkeleton />}
            />

            {/* Delete Confirmation Modal */}
            <Modal
              show={showDeleteConfirmModal}
              onHide={() => setShowDeleteConfirmModal(false)}
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Are you sure you want to delete this row?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => setShowDeleteConfirmModal(false)}
                >
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                  Yes, Delete
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default HotelSetupList;
